import type { PageNumber } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"
export const SheetCoverPageNumbers = (blueline_page_numbers: PageNumber[][]): PageNumber[] => {
  const result: PageNumber[] = []
  let prev = 0
  for (const line of blueline_page_numbers) {
    const current = line[line.length - 1]
    if (NullQ(current)) continue
    if (current >= prev) result.push(current)
    prev = current
  }
  return result
}
